module.exports = __webpack_public_path__ + "static/pexels-los-muertos-crew-8460371-1f45748fc73e715f8882d136b39f26c0.jpg";